import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './video-related-video-stack.component.scss';
import * as $ from 'jquery';
var VideoRelatedVideoStack = /** @class */ (function (_super) {
    tslib_1.__extends(VideoRelatedVideoStack, _super);
    function VideoRelatedVideoStack(element) {
        return _super.call(this, element) || this;
    }
    VideoRelatedVideoStack.prototype.init = function () {
        var _this = this;
        this.containers = Array.from(this.element.querySelectorAll('.video-related-video-stack-item__type-feature'));
        this.buttons = Array.from(this.element.querySelectorAll('.video-related-video-stack-item'));
        window.addEventListener('resize', function () {
            _this.videoSameHeight();
        });
        // create iframe attribute + add sandbox to mp4
        this.configureIframes();
    };
    VideoRelatedVideoStack.prototype.bindEvents = function () {
        var _this = this;
        this.buttons.map(function (item) { return item.addEventListener('click', function (event) {
            // variables
            var element;
            var clickedExternal;
            var clickedTarget = event.target;
            element = clickedTarget.closest('.video-related-video-stack-item');
            var clickedIndex = element.getAttribute('data-index');
            // hide containers + buttons
            _this.hideActiveButtons();
            _this.hideContainers();
            // enabled current button
            element.classList.add('active');
            // check if external
            // if(element.getAttribute('data-youtube-id')){
            // 	clickedExternal = element.getAttribute('data-youtube-id');
            // }
            // run click functions
            _this.removeIframes();
            _this.generateIframe(clickedIndex);
            // enabled current container
            // this.containers.map((item) => {
            // 	if(item.getAttribute('data-index') === clickedIndex) {
            // item.classList.remove('d-none');
            // if(document.querySelector('.header')) {
            // 	if(document.querySelector('.header').classList.contains('header--sticky')) {
            // 		$('html,body').animate({ 
            // 			scrollTop: $(this.element).offset().top - 65
            // 		}, 'slow');
            // 	}else{
            // 		$('html,body').animate({ 
            // 			scrollTop: $(this.element).offset().top - 195
            // 		}, 'slow');
            // 	}
            // }
            // if(clickedExternal) {
            // 	this.generateExternalVideo(item);
            // }
            // this.pauseOtherVideos(item);
            // 	}				
            // });
        }); });
    };
    VideoRelatedVideoStack.prototype.hideActiveButtons = function () {
        this.buttons.map(function (item) {
            item.classList.remove('active');
        });
    };
    VideoRelatedVideoStack.prototype.hideContainers = function () {
        this.containers.map(function (item) {
            item.classList.add('d-none');
        });
    };
    VideoRelatedVideoStack.prototype.hideActiveVideo = function (element) {
        var videoContainer = element.querySelector('.video');
        if (!videoContainer.classList.contains('video--playing')) {
            var videoContainers = Array.from(document.querySelectorAll('.video--playing'));
            videoContainers.map(function (itemContainer) {
                itemContainer.classList.remove('video--playing');
                var iframeExistence = itemContainer.querySelector('iframe');
                if (iframeExistence) {
                    var iframeChildren = $(itemContainer).find('iframe');
                    iframeChildren.remove();
                }
                else {
                    var videoChildren = itemContainer.querySelector('video');
                    var playerChildren = itemContainer.querySelector('.ot-video-containingBlock');
                    videoChildren.pause();
                }
            });
        }
    };
    VideoRelatedVideoStack.prototype.pauseOtherVideos = function (container) {
        if (container) {
            var dataIndex = container.getAttribute('data-index');
            this.containers.map((function (containerChild) {
                var videoContainer = containerChild.querySelector('.video-related-video-stack-item__type-feature__video-container');
                var iframes = Array.from(containerChild.querySelectorAll('iframe'));
                iframes.map(function (iframe) {
                    var clone = iframe;
                    iframe.remove();
                    videoContainer.appendChild(clone);
                });
            }));
        }
    };
    VideoRelatedVideoStack.prototype.videoSameHeight = function () {
        if (this.element.querySelector('.mejs__video')) {
            var height_1 = this.element.querySelector('.mejs__video').style.height;
            var iframes = Array.from(this.element.querySelectorAll('.youtube-video'));
            iframes.map(function (frame) {
                frame.setAttribute('height', height_1);
            });
        }
    };
    VideoRelatedVideoStack.prototype.generateExternalVideo = function (container) {
        this.videoSameHeight();
    };
    VideoRelatedVideoStack.prototype.configureIframes = function () {
        var indexContainers = 0;
        this.containers.map((function (containerChild) {
            var videoContainer = containerChild.querySelector('.video-related-video-stack-item__type-feature__video-container');
            var iframes = Array.from(containerChild.querySelectorAll('iframe'));
            iframes.forEach(function (iframe) {
                var iframeSrc = iframe.getAttribute('src');
                containerChild.setAttribute('data-iframe-url', iframeSrc);
                iframe.remove();
                if (indexContainers === 0) {
                    var createIframe = "";
                    if (iframeSrc.includes('youtube')) {
                        createIframe = "<iframe class=\"youtube-video\" width=\"100%\" height=\"467\" src=\"" + iframeSrc + "\" frameborder=\"0\" allowfullscreen></iframe>";
                    }
                    else {
                        createIframe = "<iframe class=\"youtube-video\" width=\"100%\" height=\"467\" src=\"" + iframeSrc + "\" frameborder=\"0\" allowfullscreen sandbox></iframe>";
                    }
                    videoContainer.innerHTML = createIframe;
                }
            });
            indexContainers++;
        }));
    };
    VideoRelatedVideoStack.prototype.generateIframe = function (clickedIndex) {
        this.containers.map(function (containerChild) {
            if (containerChild.getAttribute('data-index') === clickedIndex) {
                containerChild.classList.remove('d-none');
                var videoContainer = containerChild.querySelector('.video-related-video-stack-item__type-feature__video-container');
                var iframeSrc = containerChild.getAttribute('data-iframe-url');
                var createIframe = "";
                if (iframeSrc.includes('youtube')) {
                    createIframe = "<iframe class=\"youtube-video\" width=\"100%\" height=\"467\" src=\"" + iframeSrc + "\" frameborder=\"0\" allowfullscreen></iframe>";
                }
                else {
                    createIframe = "<iframe class=\"youtube-video\" width=\"100%\" height=\"467\" src=\"" + iframeSrc + "\" frameborder=\"0\" allowfullscreen sandbox></iframe>";
                }
                videoContainer.innerHTML = createIframe;
            }
        });
    };
    VideoRelatedVideoStack.prototype.removeIframes = function () {
        this.containers.map(function (containerChild) {
            var iframes = Array.from(containerChild.querySelectorAll('iframe'));
            iframes.forEach(function (iframe) {
                iframe.remove();
            });
        });
    };
    return VideoRelatedVideoStack;
}(Base));
export { VideoRelatedVideoStack };



//////////////////
// WEBPACK FOOTER
// ./components/video-related-video-stack/video-related-video-stack.component.ts
// module id = 560
// module chunks = 0